import { CardCvcElement, CardExpiryElement, CardNumberElement } from "@stripe/react-stripe-js";
import React from "react";

import InputText from "../../../components/Inputs/InputText";
import InputWrapper from "../../../components/Inputs/InputWrapper";

import type { FormErrors } from "./modals/CreditCardModal";

// Utilities
const STRIPE_ELEMENT_STYLES = {
	style: {
		base: {
			fontSize: "12px",
		},
	},
};

const CardFormFields = ({
	cardName,
	setCardName,
	cardZipCode,
	setCardZipCode,
	errors,
}: {
	cardName: string;
	setCardName: (val: string) => void;
	cardZipCode: string;
	setCardZipCode: (val: string) => void;
	errors: FormErrors;
}) => {
	return (
		<div className="space-y-4">
			<InputText
				label="Name on Card"
				placeholder="Name on Card"
				value={cardName}
				onChange={setCardName}
				errorMessage={errors.cardName}
			/>

			<InputWrapper label="Card Number">
				<div className="rounded border border-solid border-gray-400">
					<CardNumberElement id="cardNumber" options={STRIPE_ELEMENT_STYLES} className="h-full p-2" />
				</div>
			</InputWrapper>

			<div className="flex space-x-4">
				<div className="basis-1/4">
					<InputWrapper label="Expiration Date">
						<div className="rounded border border-solid border-gray-400">
							<CardExpiryElement
								id="expirationDate"
								options={STRIPE_ELEMENT_STYLES}
								className="h-full p-2"
							/>
						</div>
					</InputWrapper>
				</div>

				<div className="basis-1/4">
					<InputWrapper label="CVC">
						<div className="rounded border border-solid border-gray-400">
							<CardCvcElement id="cvc" options={STRIPE_ELEMENT_STYLES} className="h-full p-2" />
						</div>
					</InputWrapper>
				</div>

				<div className="basis-1/2">
					<InputText
						label="Zip Code"
						placeholder="Zip Code"
						value={cardZipCode}
						onChange={setCardZipCode}
						errorMessage={errors.zipCode}
					/>
				</div>
			</div>
		</div>
	);
};

export default CardFormFields;
